/**
 * Receives a keypress event and runs a function if the keypress comes from an enter.
 */
function onEnter(run) {
  return event => {
    if (event.key === 'Enter') {
      run()
    }
  }
}

function onKey(run, key) {
  return event => {
    if (event.key === key) {
      run()
    }
  }
}

export { onEnter, onKey }
